import { Heading } from 'grommet'

export default Heading
